import { v4 } from 'uuid';
import Cookies, { get } from 'js-cookie';
import React, { useMemo, useCallback, useState, useEffect, createContext, useContext, useRef } from 'react';
import { Statsig, StatsigContext, StatsigProvider } from 'statsig-react';
import { useWindowScroll, useWindowSize } from 'react-use';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Cookie;

(function (Cookie) {
  Cookie["Lang"] = "lang";
  Cookie["HeadspaceDeviceID"] = "hsDeviceId";
  Cookie["StatsigStableID"] = "statsigStableId";
  Cookie["CookiePolicyAnalytics"] = "cookiePolicyAnalytics";
  Cookie["CookiePolicyMarketing"] = "cookiePolicyMarketing";
  Cookie["CookiePolicyPerformance"] = "cookiePolicyPerformance";
  Cookie["GTMSession"] = "_sp_id.8a05=";
  Cookie["OptanonConsent"] = "OptanonConsent";
})(Cookie || (Cookie = {}));

var OneTrustAnalyticsAccepted = 'C0002:1';
var DEFAULT_COOKIE_CONFIGURATION = {
  domain: '.headspace.com',
  path: '/',
  secure: false
};
var GdprCookieValues;

(function (GdprCookieValues) {
  GdprCookieValues["Accept"] = "accept";
  GdprCookieValues["Decline"] = "decline";
  GdprCookieValues["NotSet"] = "not-set";
})(GdprCookieValues || (GdprCookieValues = {}));

var Environment;

(function (Environment) {
  Environment["Production"] = "production";
  Environment["Staging"] = "staging";
  Environment["Integration"] = "integration";
})(Environment || (Environment = {}));

var EventType;

(function (EventType) {
  EventType[EventType["Unknown"] = 0] = "Unknown";
  EventType[EventType["Navigation"] = 1] = "Navigation";
  EventType[EventType["Location"] = 2] = "Location";
  EventType[EventType["Search"] = 3] = "Search";
  EventType[EventType["Transaction"] = 4] = "Transaction";
  EventType[EventType["UserContent"] = 5] = "UserContent";
  EventType[EventType["UserPreference"] = 6] = "UserPreference";
  EventType[EventType["Social"] = 7] = "Social";
  EventType[EventType["Other"] = 8] = "Other";
  EventType[EventType["Media"] = 9] = "Media";
})(EventType || (EventType = {}));

var EventName;

(function (EventName) {
  EventName["ScreenView"] = "screen view";
  EventName["ButtonClick"] = "button clickthrough";
  EventName["PageScroll"] = "page scroll";
})(EventName || (EventName = {}));

var TagNameToEventType = {
  a: EventType.Navigation,
  button: EventType.Other
};
var STATSIG_SDK_KEY = 'client-AUIlYXXKCk5oO6j4J0DNeuR6LqIlquA0NmvGclKDUS9';

var getGTMSession = function getGTMSession() {
  var _sessionId$split; // taken from GTM session tag


  var sessionId = get(Cookie.GTMSession);
  return (sessionId == null ? void 0 : (_sessionId$split = sessionId.split('.')) == null ? void 0 : _sessionId$split.shift()) || null;
};

var getPageReferringDomain = function getPageReferringDomain(referrer) {
  var parts = referrer.split('/');

  if (parts.length >= 3) {
    return parts[2];
  }

  return undefined;
};

var getAnalyticsCookie = function getAnalyticsCookie() {
  var oneTrustConsent = get(Cookie.OptanonConsent);

  if (oneTrustConsent) {
    return decodeURIComponent(oneTrustConsent);
  }

  return get(Cookie.CookiePolicyAnalytics);
};

var getIsAnalyticsCookieAccepted = function getIsAnalyticsCookieAccepted() {
  var analyticsCookie = getAnalyticsCookie();
  return (analyticsCookie == null ? void 0 : analyticsCookie.includes(OneTrustAnalyticsAccepted)) || analyticsCookie === GdprCookieValues.Accept;
};

var getWindowObject = function getWindowObject() {
  return typeof window !== 'undefined' && window != null && typeof window === 'object' ? window : undefined;
};
/**
 * These utils are intended to connect mobile device QR code scans to the desktop flow
 * that generated the QR code, as we lose session information between devices. **This is
 * intended to be used CLIENT SIDE.** The properties are added as the URL's hash to prevent
 * user IDs from being cached by Google, wayback machine, etc.
 *
 * `createTrackableUrl` is used by the consumer in generating the QR code. The HS user ID
 * and Statsig stable ID are form-encoded and attached to the URL hash.
 *
 * `parseTrackableUrl` is primarily used by the WebAnalyticsProvider to initialize Statsig
 * and mParticle with the user IDs from the desktop flow. If WebAnalyticsProvider is not
 * being used, the consumer can still use the util to capture the IDs to make its own updates.
 *
 * `createUrlObj` / `createUrlString` are intended to allow use of URL class while preventing
 * errors if url is relative but web-analytics is running server side (ie, no location). (see
 * https://github.com/whatwg/url/issues/531#issuecomment-682158237 )
 *
 * NB: GDPR is accounted for in creating the trackable URL, when cookie preferences are
 * available. If GDPR does not equal 'accept', no parameters are appended.
 */


var trackedAttributes = ['hsUserId', 'pageReferrer', 'statsigStableId'];
var protocolPlaceholder = 'relative:/';

var createUrlObj = function createUrlObj(urlString) {
  var _windowObject$locatio, _windowObject$locatio2;

  var windowObject = getWindowObject();
  var origin = (_windowObject$locatio = windowObject == null ? void 0 : (_windowObject$locatio2 = windowObject.location) == null ? void 0 : _windowObject$locatio2.origin) != null ? _windowObject$locatio : protocolPlaceholder; // will not overwrite defined origin/protocol

  return new URL(urlString, origin);
};

var createUrlString = function createUrlString(url) {
  return url.toString().replace(protocolPlaceholder, '/');
};

var createTrackedPropertiesString = function createTrackedPropertiesString(properties) {
  var trackedPropertiesParams = new URLSearchParams();
  Object.entries(properties).forEach(function (_ref) {
    var attribute = _ref[0],
        value = _ref[1]; // only attach defined attributes

    if (value) {
      trackedPropertiesParams.set(attribute, value);
    }
  });
  return trackedPropertiesParams.toString();
};

var createTrackedPropertiesObject = function createTrackedPropertiesObject(propertiesString) {
  var trackedPropertiesObject = {};
  var propertiesParams = new URLSearchParams(propertiesString); // only return expected, defined attributes

  trackedAttributes.forEach(function (attribute) {
    var value = propertiesParams.get(attribute);

    if (value) {
      trackedPropertiesObject[attribute] = value;
    }
  });
  return trackedPropertiesObject;
};

function createTrackableUrl(urlString, hsUserId) {
  var _windowObject$locatio3;

  var newUrl = createUrlObj(urlString);
  var windowObject = getWindowObject();

  if (newUrl.hash || !getIsAnalyticsCookieAccepted()) {
    return urlString;
  }

  newUrl.hash = createTrackedPropertiesString({
    hsUserId: hsUserId,
    pageReferrer: windowObject == null ? void 0 : (_windowObject$locatio3 = windowObject.location) == null ? void 0 : _windowObject$locatio3.href,
    statsigStableId: get(Cookie.StatsigStableID)
  });
  return createUrlString(newUrl);
}

function parseTrackableUrl(urlString) {
  var url = createUrlObj(urlString != null ? urlString : '');
  var trackedPropertiesString = url == null ? void 0 : url.hash.slice(1); // remove initial '#'

  return createTrackedPropertiesObject(trackedPropertiesString);
}

var _excluded = ["domain_userid", "page_title", "page_url"];

function createNewWebContract(contract) {
  var _ref2, _ref3, _contract$page_referr, _windowObject$documen, _ref4, _ref5;

  var _ref = contract || {},
      domain_userid = _ref.domain_userid,
      page_title = _ref.page_title,
      page_url = _ref.page_url,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var windowObject = getWindowObject();

  var _parseTrackableUrl = parseTrackableUrl(windowObject == null ? void 0 : windowObject.location.href),
      pageReferrer = _parseTrackableUrl.pageReferrer;

  var page_referrer = (_ref2 = (_ref3 = (_contract$page_referr = contract == null ? void 0 : contract.page_referrer) != null ? _contract$page_referr : pageReferrer) != null ? _ref3 : windowObject == null ? void 0 : (_windowObject$documen = windowObject.document) == null ? void 0 : _windowObject$documen.referrer) != null ? _ref2 : '';
  var page_referrer_domain = getPageReferringDomain(page_referrer);
  return _extends({}, rest, {
    domain_userid: domain_userid || getGTMSession(),
    page_referrer: page_referrer,
    page_referrer_domain: page_referrer_domain,
    page_title: (_ref4 = page_title != null ? page_title : windowObject == null ? void 0 : windowObject.document.title) != null ? _ref4 : '',
    page_url: (_ref5 = page_url != null ? page_url : windowObject == null ? void 0 : windowObject.location.href) != null ? _ref5 : ''
  });
}

var flattenContractObject = function flattenContractObject(contractObject) {
  var contract = _extends({}, contractObject, {
    web: contractObject.web || createNewWebContract()
  });

  return Object.keys(contract).reduce(function (acc, curr) {
    return _extends({}, acc, contract[curr]);
  }, {});
};

var DeviceType;

(function (DeviceType) {
  DeviceType["Desktop"] = "desktop";
  DeviceType["Mobile"] = "mobile";
})(DeviceType || (DeviceType = {}));

var PointerTypeQuery;

(function (PointerTypeQuery) {
  PointerTypeQuery["Coarse"] = "(pointer: coarse)";
  PointerTypeQuery["Fine"] = "(pointer: fine)";
})(PointerTypeQuery || (PointerTypeQuery = {}));

var useMatchMedia = function useMatchMedia(queries) {
  var windowObject = getWindowObject();
  var mediaQueryLists = useMemo(function () {
    return queries.map(function (q) {
      return windowObject == null ? void 0 : windowObject.matchMedia == null ? void 0 : windowObject.matchMedia(q);
    });
  }, [queries, windowObject]);
  var getValue = useCallback(function () {
    return mediaQueryLists.map(function (mql) {
      return mql == null ? void 0 : mql.matches;
    });
  }, [mediaQueryLists]);

  var _useState = useState(getValue),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    var handler = function handler() {
      return setValue(getValue);
    };

    mediaQueryLists.forEach(function (mql) {
      return mql == null ? void 0 : mql.addEventListener == null ? void 0 : mql.addEventListener('change', handler);
    });
    return function () {
      mediaQueryLists.forEach(function (mql) {
        return mql == null ? void 0 : mql.removeEventListener == null ? void 0 : mql.removeEventListener('change', handler);
      });
    };
  }, [getValue, mediaQueryLists]);
  return value;
};
/**
 * React hook to determine if user is on a desktop or mobile device.
 *
 * Please note that there is no "true" way of determining if a user is
 * actually on their desktop or mobile device. Many sources online pointed
 * to the usage of `window.navigator.userAgent`. However, Mozilla stated
 * the usage of `window.navigator.userAgent`is very rarely a good idea since
 * browers can easily (and actively) manipulate it.
 *
 * Using `MediaQuery` seems to be the most plausible solution yet. Though not
 * 100% resilient, it seems to do the job fairly well.
 *
 * `pointer: coarse` = The primary input mechanism includes a pointing device of
 * limited accuracy, such as a finger on a touchscreen.
 *
 * `pointer: fine` = The primary input mechanism includes an accurate pointing
 * device, such as a mouse.
 *
 * `if (coarse === true && fine === true) return DeviceType.Desktop`
 *
 * `if (coarse === false && fine === true) return DeviceType.Desktop`
 *
 * `if (coarse === true && fine === false) return DeviceType.Mobile`
 */


var useDeviceType = function useDeviceType() {
  var pointerTypeQueries = useMemo(function () {
    return [PointerTypeQuery.Coarse, PointerTypeQuery.Fine];
  }, []);

  var _useMatchMedia = useMatchMedia(pointerTypeQueries),
      coarsePointerMatch = _useMatchMedia[0],
      finePointerMatch = _useMatchMedia[1];

  var isMobile = coarsePointerMatch && !finePointerMatch;

  if (isMobile) {
    return DeviceType.Mobile;
  }

  return DeviceType.Desktop;
};

var getAmplitudeInstance = function getAmplitudeInstance() {
  var _windowObject$amplitu, _instances$test;

  var windowObject = getWindowObject();

  var _ref = (_windowObject$amplitu = windowObject == null ? void 0 : windowObject.amplitude) != null ? _windowObject$amplitu : {},
      _instances = _ref._instances;

  var instance = (_instances$test = _instances == null ? void 0 : _instances.test) != null ? _instances$test : _instances == null ? void 0 : _instances.$default_instance;
  return instance;
};

var setAmplitudeDeviceId = function setAmplitudeDeviceId(newDeviceId) {
  var amplitudeInstance = getAmplitudeInstance();
  amplitudeInstance == null ? void 0 : amplitudeInstance.setDeviceId(newDeviceId);
};

var WebAnalyticsContext = /*#__PURE__*/createContext({
  countryCode: undefined,
  customerId: '',
  deviceId: '',
  locale: undefined,
  setCustomerId: function setCustomerId() {
    return undefined;
  },
  userId: undefined
});
/**
 * Hook provides a function to call to log an event to mparticle, or to a different source with manual override
 * @param logEventFn - optional function to call to log event, will log of window.mParticle.logEvent by default
 */

var useGetLogEvent = function useGetLogEvent(logEventFn) {
  if (logEventFn === void 0) {
    var _getWindowObject, _getWindowObject$mPar;

    logEventFn = (_getWindowObject = getWindowObject()) == null ? void 0 : (_getWindowObject$mPar = _getWindowObject.mParticle) == null ? void 0 : _getWindowObject$mPar.logEvent;
  }

  var _useContext = useContext(WebAnalyticsContext),
      deviceId = _useContext.deviceId;

  var event_device_type = useDeviceType();
  return useCallback(function (_ref) {
    var eventName = _ref.eventName,
        eventType = _ref.eventType,
        _ref$contracts = _ref.contracts,
        contracts = _ref$contracts === void 0 ? {} : _ref$contracts;
    var isAnalyticsCookieAccepted = getIsAnalyticsCookieAccepted();

    if (isAnalyticsCookieAccepted && logEventFn) {
      if (deviceId) {
        setAmplitudeDeviceId(deviceId);
      }

      var attributes = _extends({}, flattenContractObject(contracts), {
        event_device_type: event_device_type,
        userAgent: navigator.userAgent
      });

      logEventFn == null ? void 0 : logEventFn(eventName, eventType, attributes);
    }
  }, [deviceId, event_device_type, logEventFn]);
};

var _excluded$1 = ["eventName", "value"];
/**
 * Hook provides a function to call to log an event to Statsig, or to a different source with manual override
 * @param logExperimentEventFn - optional function to call to log event, will log to Statsig.logEvent by default
 */

var useGetLogExperimentEvent = function useGetLogExperimentEvent(logExperimentEventFn) {
  if (logExperimentEventFn === void 0) {
    logExperimentEventFn = Statsig.logEvent.bind(Statsig);
  }

  var windowObject = getWindowObject();

  var _useContext = useContext(StatsigContext),
      initStarted = _useContext.initStarted;

  var returnFunc = useCallback(function (_ref) {
    var eventName = _ref.eventName,
        value = _ref.value,
        args = _objectWithoutPropertiesLoose(_ref, _excluded$1);

    var isAnalyticsCookieAccepted = getIsAnalyticsCookieAccepted();

    if (initStarted && isAnalyticsCookieAccepted) {
      var _windowObject$locatio, _windowObject$locatio2;

      var metadata = _extends({}, args.metadata, {
        page_url: (_windowObject$locatio = windowObject == null ? void 0 : (_windowObject$locatio2 = windowObject.location) == null ? void 0 : _windowObject$locatio2.href) != null ? _windowObject$locatio : ''
      });

      logExperimentEventFn(eventName, value, metadata);
    }
  }, [logExperimentEventFn, initStarted, windowObject]);
  return returnFunc;
};
/**
 * Hook provides a function to call to log a page view event to mparticle, or to a different source with manual override
 * @param logPageViewFn - optional function to call to log event, will log of window.mParticle.logPageView by default
 */


var useGetLogPageViewEvent = function useGetLogPageViewEvent(logPageViewFn) {
  if (logPageViewFn === void 0) {
    var _getWindowObject, _getWindowObject$mPar;

    logPageViewFn = (_getWindowObject = getWindowObject()) == null ? void 0 : (_getWindowObject$mPar = _getWindowObject.mParticle) == null ? void 0 : _getWindowObject$mPar.logPageView;
  }

  var _useContext = useContext(WebAnalyticsContext),
      deviceId = _useContext.deviceId;

  var event_device_type = useDeviceType();
  var returnFunc = useCallback(function (_ref) {
    var eventName = _ref.eventName,
        _ref$contracts = _ref.contracts,
        contracts = _ref$contracts === void 0 ? {} : _ref$contracts;
    var isAnalyticsCookieAccepted = getIsAnalyticsCookieAccepted();

    if (isAnalyticsCookieAccepted && logPageViewFn) {
      if (deviceId) {
        setAmplitudeDeviceId(deviceId);
      }

      var attributes = _extends({}, flattenContractObject(contracts), {
        event_device_type: event_device_type,
        userAgent: navigator.userAgent
      });

      logPageViewFn == null ? void 0 : logPageViewFn(eventName, attributes);
    }
  }, [deviceId, event_device_type, logPageViewFn]);
  return returnFunc;
};

var SCROLL_POINTS = [25, 50, 75, Infinity];

var useGetLogScrollEvent = function useGetLogScrollEvent(logEventFn) {
  var _getWindowObject$docu, _getWindowObject2, _getWindowObject2$doc, _getWindowObject2$doc2;

  if (logEventFn === void 0) {
    var _getWindowObject, _getWindowObject$mPar;

    logEventFn = (_getWindowObject = getWindowObject()) == null ? void 0 : (_getWindowObject$mPar = _getWindowObject.mParticle) == null ? void 0 : _getWindowObject$mPar.logEvent;
  }

  var logEvent = useGetLogEvent(logEventFn);
  var logExperimentEvent = useGetLogExperimentEvent();

  var _useState = useState(0),
      scrollHasReachedIndex = _useState[0],
      setScrollHasReachedIndex = _useState[1];

  var _useState2 = useState(false),
      isAlreadyBottom = _useState2[0],
      setIsAlreadyBottom = _useState2[1];

  var _useState3 = useState(false),
      userHasScrolledY = _useState3[0],
      setUserHasScrolledY = _useState3[1];

  var _useWindowScroll = useWindowScroll(),
      y = _useWindowScroll.y;

  var _useWindowSize = useWindowSize(),
      height = _useWindowSize.height;

  var pageHeight = (_getWindowObject$docu = (_getWindowObject2 = getWindowObject()) == null ? void 0 : (_getWindowObject2$doc = _getWindowObject2.document) == null ? void 0 : (_getWindowObject2$doc2 = _getWindowObject2$doc.body) == null ? void 0 : _getWindowObject2$doc2.scrollHeight) != null ? _getWindowObject$docu : 0;
  var scrollHeight = pageHeight - height;
  useEffect(function () {
    setUserHasScrolledY(!!y || userHasScrolledY);
  }, [y, userHasScrolledY]);
  /**
   * Calculates scroll percent as the percent of scrollable distance covered at and if page has scrolled to bottom.
   * Will log scrolls at >25, 50, 75 and AT page bottom (100)
   * It will not trigger an event for the same scroll position twice
   * (i.e. scrolling halfway down, then back to top, then 3/4 down will only trigger 3 events)
   */

  return useCallback(function () {
    var isAnalyticsCookieAccepted = getIsAnalyticsCookieAccepted();
    var percent = (y * 100 / Math.floor(scrollHeight)).toString().split('.')[0] || '0';
    var reachedBottom = y + 1 > scrollHeight * 0.9; // checks for above 90% because 100% "onscroll" triggers on the starting location

    if (pageHeight > 0 && (Number(percent) >= SCROLL_POINTS[scrollHasReachedIndex] || reachedBottom) && !isAlreadyBottom && userHasScrolledY && isAnalyticsCookieAccepted) {
      var _getWindowObject3, _getWindowObject3$loc;

      var scrollValue = reachedBottom ? "100% scroll" : SCROLL_POINTS[scrollHasReachedIndex] + "% scroll";
      logExperimentEvent({
        eventName: EventName.PageScroll,
        value: scrollValue
      });
      logEvent({
        contracts: {
          screenview: {
            screen_name: (_getWindowObject3 = getWindowObject()) == null ? void 0 : (_getWindowObject3$loc = _getWindowObject3.location) == null ? void 0 : _getWindowObject3$loc.href,
            screen_variant: scrollValue
          }
        },
        eventName: EventName.PageScroll,
        eventType: EventType.Other
      });

      if (reachedBottom) {
        setIsAlreadyBottom(true);
      } else {
        setScrollHasReachedIndex(scrollHasReachedIndex + 1);
      }
    }
  }, [y, scrollHeight, pageHeight, scrollHasReachedIndex, isAlreadyBottom, userHasScrolledY, logExperimentEvent, logEvent]);
};
/* eslint-disable no-undef */


var DEFAULT_GETTER_OPTIONS = {
  bubble: true
};

var isHTMLElement = function isHTMLElement(el) {
  return el instanceof HTMLElement;
};

var isHTMLElementWithTagName = function isHTMLElementWithTagName(el, tagName) {
  return isHTMLElement(el) && el.tagName.toLowerCase() === tagName;
};

var isHTMLElementWithRole = function isHTMLElementWithRole(el, role) {
  return isHTMLElement(el) && el.getAttribute('role') === role;
};

function getElementWithTagName(el, tagName, options) {
  if (options === void 0) {
    options = DEFAULT_GETTER_OPTIONS;
  }

  var _options = options,
      bubble = _options.bubble;

  if (isHTMLElementWithTagName(el, tagName)) {
    return el;
  }

  if (bubble && isHTMLElement(el)) {
    return getElementWithTagName(el.parentNode, tagName, options);
  }

  return undefined;
}

function getElementTextValue(element) {
  return element.innerText || element.getAttribute('aria-label') || '';
}

function getElementWithRole(el, role, options) {
  if (options === void 0) {
    options = DEFAULT_GETTER_OPTIONS;
  }

  var _options2 = options,
      bubble = _options2.bubble;

  if (isHTMLElementWithRole(el, role)) {
    return el;
  }

  if (bubble && isHTMLElement(el)) {
    return getElementWithRole(el.parentNode, role, options);
  }

  return undefined;
}

var getQueryParameterByName = function getQueryParameterByName(name, url) {
  if (url === void 0) {
    var _getWindowObject$loca, _getWindowObject, _getWindowObject$loca2;

    url = (_getWindowObject$loca = (_getWindowObject = getWindowObject()) == null ? void 0 : (_getWindowObject$loca2 = _getWindowObject.location) == null ? void 0 : _getWindowObject$loca2.search) != null ? _getWindowObject$loca : '';
  }

  var urlParams = new URLSearchParams(url);
  var param = urlParams.get(name);

  if (param) {
    return encodeURIComponent(param);
  }

  return null;
};

var _excluded$2 = ["survey_name", "survey_cadence"];
var originPageQueryString = 'origin';

function createNewScreenViewContract(contract) {
  var _getWindowObject, _getWindowObject$docu;

  var _ref = contract || {},
      survey_name = _ref.survey_name,
      survey_cadence = _ref.survey_cadence,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var screenAttributes = _extends({}, rest, {
    origin_page: getQueryParameterByName(originPageQueryString),
    screen_view_source: (_getWindowObject = getWindowObject()) == null ? void 0 : (_getWindowObject$docu = _getWindowObject.document) == null ? void 0 : _getWindowObject$docu.referrer
  });

  if (survey_name) {
    return _extends({}, screenAttributes, {
      survey_cadence: survey_cadence,
      survey_date: Date.now(),
      survey_name: survey_name
    });
  }

  return screenAttributes;
}

var getStatsigUser = function getStatsigUser(_ref) {
  var _amplitudeInstance$op;

  var countryCode = _ref.countryCode,
      locale = _ref.locale,
      userId = _ref.userId;
  var amplitudeInstance = getAmplitudeInstance();
  var amplitudeDeviceId = (amplitudeInstance == null ? void 0 : (_amplitudeInstance$op = amplitudeInstance.options) == null ? void 0 : _amplitudeInstance$op.deviceId) || '';
  return {
    country: countryCode,
    customIDs: {
      amplitudeDeviceId: amplitudeDeviceId
    },
    locale: locale,
    userID: userId
  };
}; // https://docs.mparticle.com/developers/sdk/web/idsync/#client-side-codes


var mParticleHTTPCodes = {
  activeIdentityRequest: -2,
  activeSession: -3,
  nativeIdentityRequest: -5,
  noHttpCoverage: -1,
  validationIssue: -4
};
var mParticleHTTPCodesSet = /*#__PURE__*/new Set( /*#__PURE__*/Object.values(mParticleHTTPCodes));

var isClientSideMParticleCode = function isClientSideMParticleCode(httpCode) {
  return typeof httpCode === 'number' && mParticleHTTPCodesSet.has(httpCode);
};

var MPARTICLE_LOGIN_RETRIES = 4;

var normalizeProps = function normalizeProps(props) {
  var _windowObject$locatio;

  var windowObject = getWindowObject();

  var _parseTrackableUrl = parseTrackableUrl(windowObject == null ? void 0 : (_windowObject$locatio = windowObject.location) == null ? void 0 : _windowObject$locatio.href),
      hsUserId = _parseTrackableUrl.hsUserId;

  return _extends({}, props, {
    // eslint-disable-next-line react/destructuring-assignment
    userId: hsUserId != null ? hsUserId : props.userId
  });
};

var getDeviceId = function getDeviceId() {
  var _windowObject$locatio2, _ref, _ref2;

  var windowObject = getWindowObject();

  var _parseTrackableUrl2 = parseTrackableUrl(windowObject == null ? void 0 : (_windowObject$locatio2 = windowObject.location) == null ? void 0 : _windowObject$locatio2.href),
      statsigStableId = _parseTrackableUrl2.statsigStableId;

  return (_ref = (_ref2 = statsigStableId != null ? statsigStableId : Cookies.get(Cookie.StatsigStableID)) != null ? _ref2 : Cookies.get(Cookie.HeadspaceDeviceID)) != null ? _ref : v4();
};

var getStatsigOptions = function getStatsigOptions(_ref3) {
  var deviceId = _ref3.deviceId,
      environment = _ref3.environment;
  return {
    environment: {
      tier: environment === Environment.Integration ? 'development' : environment
    },
    overrideStableID: deviceId
  };
};

var WebAnalyticsContextProvider = function WebAnalyticsContextProvider(_ref4) {
  var children = _ref4.children,
      countryCode = _ref4.countryCode,
      deviceId = _ref4.deviceId,
      locale = _ref4.locale,
      userId = _ref4.userId;

  var _useState = useState(),
      customerId = _useState[0],
      setCustomerId = _useState[1];

  var value = useMemo(function () {
    return {
      countryCode: countryCode,
      customerId: customerId,
      deviceId: deviceId,
      locale: locale,
      setCustomerId: setCustomerId,
      userId: userId
    };
  }, [countryCode, customerId, deviceId, locale, userId]);
  return React.createElement(WebAnalyticsContext.Provider, {
    value: value
  }, children);
};

var InternalProvider = function InternalProvider(_ref5) {
  var _windowObject$locatio3, _windowObject$mPartic3;

  var children = _ref5.children,
      onUserIdentifyFailure = _ref5.onUserIdentifyFailure,
      onUserIdentifySuccess = _ref5.onUserIdentifySuccess;

  var _useContext = useContext(StatsigContext),
      initStarted = _useContext.initStarted;

  var _useContext2 = useContext(WebAnalyticsContext),
      countryCode = _useContext2.countryCode,
      customerId = _useContext2.customerId,
      locale = _useContext2.locale,
      setCustomerId = _useContext2.setCustomerId,
      userId = _useContext2.userId;

  var _useState2 = useState(MPARTICLE_LOGIN_RETRIES),
      mParticleLoginRetries = _useState2[0],
      setMParticleLoginRetries = _useState2[1];

  var isLoginCallInProgress = useRef(false);
  var windowObject = getWindowObject();

  var _ref6 = (_windowObject$locatio3 = windowObject == null ? void 0 : windowObject.location) != null ? _windowObject$locatio3 : {},
      pathname = _ref6.pathname,
      search = _ref6.search;

  var logEvent = useGetLogEvent();
  var logPageView = useGetLogPageViewEvent();
  var logExperimentEvent = useGetLogExperimentEvent();
  var logScrollEvent = useGetLogScrollEvent();
  useEffect(function () {
    var _windowObject$mPartic, _windowObject$mPartic2; // if `userId` does not exist, then there is no need to log in
    // if `customerId` exists, then we already successfully logged in
    // if `mParticlesLoginRetries` is 0, then we maxed out log in attempts


    if (!userId || customerId || !mParticleLoginRetries) return;

    if (initStarted) {
      var statsigUser = getStatsigUser({
        countryCode: countryCode,
        locale: locale,
        userId: userId
      });
      Statsig.updateUser(statsigUser);
    }

    var amplitudeInstance = getAmplitudeInstance();
    amplitudeInstance == null ? void 0 : amplitudeInstance.setUserId(userId);

    var _ref7 = (_windowObject$mPartic = windowObject == null ? void 0 : (_windowObject$mPartic2 = windowObject.mParticle) == null ? void 0 : _windowObject$mPartic2.Identity) != null ? _windowObject$mPartic : {},
        login = _ref7.login;

    var setLoginRetriesTimeout = function setLoginRetriesTimeout() {
      return setTimeout(function () {
        return setMParticleLoginRetries(function (loginRetries) {
          return loginRetries - 1;
        });
      }, 1000);
    };

    if (typeof login === 'function' && !isLoginCallInProgress.current) {
      isLoginCallInProgress.current = true;
      login({
        userIdentities: {
          customerid: userId
        }
      }, function (result) {
        isLoginCallInProgress.current = false;

        var _ref8 = result != null ? result : {},
            getUser = _ref8.getUser,
            httpCode = _ref8.httpCode;

        var user = getUser == null ? void 0 : getUser(); // Code is written based-off of mParticle's doc
        // https://docs.mparticle.com/developers/sdk/web/idsync/#login-and-logout

        if (user) {
          var _user$getUserIdentiti;

          var _ref9 = (_user$getUserIdentiti = user.getUserIdentities == null ? void 0 : user.getUserIdentities()) != null ? _user$getUserIdentiti : {},
              userIdentities = _ref9.userIdentities;

          var _ref10 = userIdentities || {},
              mParticleCustomerid = _ref10.customerid;

          onUserIdentifySuccess == null ? void 0 : onUserIdentifySuccess(result);
          setCustomerId(mParticleCustomerid);
          setMParticleLoginRetries(0);
          return;
        }

        if (isClientSideMParticleCode(httpCode)) {
          onUserIdentifyFailure == null ? void 0 : onUserIdentifyFailure(result);
          setLoginRetriesTimeout();
        }
      });
    } else {
      // If mParticle's login function is undefined, we should try again
      // after 1000ms until the function exist or when we run out of retries
      onUserIdentifyFailure == null ? void 0 : onUserIdentifyFailure();
      setLoginRetriesTimeout();
    }
  }, [countryCode, customerId, initStarted, locale, mParticleLoginRetries, onUserIdentifyFailure, onUserIdentifySuccess, setCustomerId, userId, windowObject == null ? void 0 : (_windowObject$mPartic3 = windowObject.mParticle) == null ? void 0 : _windowObject$mPartic3.Identity]);
  useEffect(function () {
    logPageView({
      contracts: {
        screenview: createNewScreenViewContract(),
        web: createNewWebContract()
      },
      eventName: EventName.ScreenView
    });
  }, [pathname, logPageView, search]);
  useEffect(function () {
    var scrollListener = function scrollListener() {
      return logScrollEvent();
    };

    var clickListener = function clickListener(event) {
      var _ref11, _ref12, _getElementWithTagNam;

      var element = (_ref11 = (_ref12 = (_getElementWithTagNam = getElementWithTagName(event.target, 'button')) != null ? _getElementWithTagNam : getElementWithTagName(event.target, 'a')) != null ? _ref12 : getElementWithRole(event.target, 'button')) != null ? _ref11 : getElementWithTagName(event.target, 'input');

      if (element) {
        var _element$getAttribute, _element$getAttribute2;

        var cta_label = getElementTextValue(element);
        var href = (_element$getAttribute = element.getAttribute('href')) != null ? _element$getAttribute : '';

        if (!cta_label) {
          // eslint-disable-next-line no-console
          console.warn('Click event has no cta_label, event will be logged with missing information!');
        }

        logExperimentEvent({
          eventName: EventName.ButtonClick,
          metadata: {
            cta_label: cta_label,
            href: href
          },
          value: cta_label
        });
        logEvent({
          contracts: {
            activity: {
              activity_status: 'complete',
              activity_type: 'cta',
              cta_label: cta_label,
              cta_link: (_element$getAttribute2 = element.getAttribute('href')) != null ? _element$getAttribute2 : ''
            }
          },
          eventName: EventName.ButtonClick,
          eventType: TagNameToEventType[element.tagName.toLocaleLowerCase()] || EventType.Other
        });
      }
    };

    windowObject == null ? void 0 : windowObject.addEventListener == null ? void 0 : windowObject.addEventListener('click', clickListener);
    windowObject == null ? void 0 : windowObject.addEventListener == null ? void 0 : windowObject.addEventListener('scroll', scrollListener);
    return function () {
      windowObject == null ? void 0 : windowObject.removeEventListener == null ? void 0 : windowObject.removeEventListener('click', clickListener);
      windowObject == null ? void 0 : windowObject.removeEventListener == null ? void 0 : windowObject.removeEventListener('scroll', scrollListener);
    };
  }, [logEvent, logExperimentEvent, logScrollEvent, windowObject]);
  return children;
};

var WebAnalyticsProvider = function WebAnalyticsProvider(props) {
  var windowObject = getWindowObject();
  var deviceId = useMemo(function () {
    return getDeviceId();
  }, []);
  var internalProps = normalizeProps(props);
  var children = internalProps.children,
      countryCode = internalProps.countryCode,
      environment = internalProps.environment,
      initializeExperiment = internalProps.initializeExperiment,
      locale = internalProps.locale,
      userId = internalProps.userId;
  var statsigUser = useMemo(function () {
    return getStatsigUser({
      countryCode: countryCode,
      locale: locale,
      userId: userId
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [countryCode, locale]);
  var statsigOptions = useMemo(function () {
    return getStatsigOptions({
      deviceId: deviceId,
      environment: environment
    });
  }, [environment, deviceId]);
  useEffect(function () {
    // mParticle uses `window.AmplitudeInitSettings` to allow clients to configure their
    // Amplitude instance. We want to set Amplitude's Device ID before mParticle initializes
    // Amplitude on our behalf.
    // https://github.com/mparticle-integrations/mparticle-javascript-integration-amplitude/blob/7c70bae47697b089aff9855a11e2295b902fe201/src/Amplitude.js#L662
    if (windowObject) {
      windowObject.AmplitudeInitSettings = _extends({}, windowObject.AmplitudeInitSettings, {
        deviceId: deviceId
      });
    } // We're calling `setAmplitudeDeviceId(deviceId) here as well in the cases where mParticle
    // has already initialized Amplitude before it reaches this code.


    setAmplitudeDeviceId(deviceId);
    Cookies.set(Cookie.HeadspaceDeviceID, deviceId, _extends({}, DEFAULT_COOKIE_CONFIGURATION, {
      expires: 365,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      sameSite: 'Lax'
    }));
  }, [deviceId, windowObject]);

  if (windowObject && !(windowObject != null && windowObject.mParticle)) {
    // eslint-disable-next-line no-console
    console.warn('window.mParticle is undefined. Please initialize mParticle.');
  }

  if (!initializeExperiment) {
    return React.createElement(WebAnalyticsContextProvider, {
      countryCode: countryCode,
      locale: locale,
      deviceId: deviceId,
      userId: userId
    }, React.createElement(InternalProvider, Object.assign({}, internalProps), children));
  }

  return React.createElement(StatsigProvider, {
    options: statsigOptions,
    sdkKey: STATSIG_SDK_KEY,
    user: statsigUser
  }, React.createElement(WebAnalyticsContextProvider, {
    countryCode: countryCode,
    locale: locale,
    deviceId: deviceId,
    userId: userId
  }, React.createElement(InternalProvider, Object.assign({}, internalProps), children)));
};

var useExperiment = function useExperiment(options) {
  var isAnalyticsCookieAccepted = getIsAnalyticsCookieAccepted();
  var experimentName = options.experimentName;
  var experimentLocales = options.experimentLocales || [];

  var _useContext = useContext(StatsigContext),
      initialized = _useContext.initialized,
      initStarted = _useContext.initStarted,
      userVersion = _useContext.userVersion;

  var localeCookie = Cookies.get(Cookie.Lang);
  var isLocaleUndefined = experimentLocales.length === 0;
  var isLocaleMatch = experimentLocales.some(function (l) {
    return localeCookie === l;
  });
  var experiment = useMemo(function () {
    if (experimentName && initStarted && isAnalyticsCookieAccepted && (isLocaleUndefined || isLocaleMatch)) {
      var _Statsig$getExperimen = Statsig.getExperiment(experimentName),
          value = _Statsig$getExperimen.value;

      return {
        value: value
      };
    }

    return {}; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [experimentName, experimentLocales, isAnalyticsCookieAccepted, initialized, initStarted, isLocaleUndefined, isLocaleMatch, userVersion]);
  return {
    experiment: experiment,
    isLoading: !initialized
  };
};

var useGetExperiment = function useGetExperiment() {
  var _useContext = useContext(StatsigContext),
      initialized = _useContext.initialized,
      initStarted = _useContext.initStarted,
      userVersion = _useContext.userVersion;

  var _useContext2 = useContext(WebAnalyticsContext),
      countryCode = _useContext2.countryCode,
      deviceId = _useContext2.deviceId,
      locale = _useContext2.locale,
      userId = _useContext2.userId;

  var localeCookie = Cookies.get(Cookie.Lang);
  var getExperiment = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
      var isAnalyticsCookieAccepted, experimentName, experimentLocales, isLocaleUndefined, isLocaleMatch, statsigUser, _Statsig$getExperimen, value;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              isAnalyticsCookieAccepted = getIsAnalyticsCookieAccepted();
              experimentName = options.experimentName;
              experimentLocales = options.experimentLocales || [];
              isLocaleUndefined = experimentLocales.length === 0;
              isLocaleMatch = experimentLocales.some(function (l) {
                return locale === l || localeCookie === l;
              });

              if (!(experimentName && initStarted && isAnalyticsCookieAccepted && (isLocaleUndefined || isLocaleMatch))) {
                _context.next = 13;
                break;
              }

              if (deviceId) {
                setAmplitudeDeviceId(deviceId);
              }

              statsigUser = getStatsigUser({
                countryCode: countryCode,
                locale: locale,
                userId: userId
              });
              _context.next = 11;
              return Statsig.updateUser(statsigUser);

            case 11:
              _Statsig$getExperimen = Statsig.getExperiment(experimentName), value = _Statsig$getExperimen.value;
              return _context.abrupt("return", {
                experiment: {
                  value: value
                },
                isLoading: !initialized
              });

            case 13:
              return _context.abrupt("return", {
                experiment: {},
                isLoading: !initialized
              });

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0); // eslint-disable-next-line no-console

              console.warn('Statsig.updateUser failed', _context.t0);
              return _context.abrupt("return", {
                experiment: {},
                isLoading: !initialized
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), // eslint-disable-next-line react-hooks/exhaustive-deps
  [initialized, initStarted, userVersion]);
  return getExperiment;
};

var useWebAnalyticsContext = function useWebAnalyticsContext() {
  return useContext(WebAnalyticsContext);
};

var Locale;

(function (Locale) {
  Locale["English"] = "en";
  Locale["German"] = "de";
  Locale["French"] = "fr";
  Locale["Portuguese"] = "pt";
  Locale["Spanish"] = "es";
})(Locale || (Locale = {}));

export { DeviceType, Environment, EventName, EventType, Locale, MPARTICLE_LOGIN_RETRIES, TagNameToEventType, WebAnalyticsProvider, createNewWebContract, createTrackableUrl, mParticleHTTPCodes, mParticleHTTPCodesSet, parseTrackableUrl, useDeviceType, useExperiment, useGetExperiment, useGetLogEvent, useGetLogExperimentEvent, useGetLogPageViewEvent, useGetLogScrollEvent, useWebAnalyticsContext };